import { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getProjectById } from '../../../services/projects.service';
import '../styles/STAI2GuestAccess.scss';
import { guestAuth } from '../VideoCall/stai2Service';

const STAI2GuestAccess = () => {
  const history = useHistory();
  const location = useLocation();
  const [guestName, setGuestName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [projectLoading, setProjectLoading] = useState(true);
  const [project, setProject] = useState(null);

  // Leggi ID dalla query string
  const searchParams = new URLSearchParams(location.search);
  const projectId = searchParams.get('id');
  const hideBackButton = searchParams.get('h') === '1';

  // Carica i dettagli del progetto
  useEffect(() => {
    const loadProject = async () => {
      if (!projectId) {
        setError('ID progetto mancante');
        setProjectLoading(false);
        return;
      }

      try {
        console.log('📦 Loading project details for ID:', projectId);
        const response = await getProjectById(projectId);
        const projectData = response.data || response;
        console.log('✅ Project loaded:', projectData);
        setProject(projectData);
        if (!projectData.request_name) {
          setGuestName('Utente');
        }
      } catch (err) {
        console.error('❌ Error loading project:', err);
        setError('Errore nel caricamento del progetto');
      } finally {
        setProjectLoading(false);
      }
    };

    loadProject();
  }, [projectId]);

  const joinSTAI2Queue = async (event) => {
    event.preventDefault();

    if (!guestName.trim()) {
      setError('Inserisci il tuo nome per continuare');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const response = await guestAuth({ guestName: guestName.trim(), projectId: projectId });

      if (response.data) {
        localStorage.setItem('stai2SessionToken', response.data.sessionToken);

        console.log('STAI2 - Guest joined queue:', response.data);

        // ✅ DIRECT FLOW: Go directly to VideoCallPage - no intermediate waiting page needed
        localStorage.setItem(
          'stai2CallData',
          JSON.stringify({
            sessionToken: response.data.sessionToken,
            guestName: guestName,
            isGuest: true,
            isWaiting: true
          })
        );

        console.log('📍 STAI2 - Going directly to VideoCallPage');
        history.push(
          `/guest-call?sessionToken=${response.data.sessionToken}&guestName=${encodeURIComponent(
            guestName
          )}&projectId=${projectId}`
        );
      } else {
        setError(response.data.message || "Errore durante l'accesso. Riprova.");
      }
    } catch (error) {
      console.error('Errore accesso STAI2:', error);
      setError('Errore di connessione. Riprova.');
    } finally {
      setIsLoading(false);
    }
  };

  const goBack = () => {
    history.push('/project-selection');
  };

  if (projectLoading) {
    return (
      <div className="stai2-guest-access loading">
        <div className="spinner-border" role="status">
          <span className="visually-hidden"></span>
        </div>
      </div>
    );
  }

  return (
    <div className="stai2-guest-access">
      <div className="container">
        <div className="row mb-2">
          <div className="col-12 text-center">
            <h1 className="main-title">{project.introduction_text}</h1>
          </div>
        </div>

        <div className="access-container">
          <div className="access-card">
            <div className="card-icon">
              {project.logo && <img src={project.logo} alt={project.name} />}
            </div>

            <form onSubmit={joinSTAI2Queue}>
              <div className={'form-group ' + (project.request_name ? '' : 'd-none')}>
                <label htmlFor="guestName" className="form-label text-center">
                  Inserisci il tuo nome
                </label>
                <input
                  type="text"
                  id="guestName"
                  className="form-input"
                  value={guestName}
                  onChange={(e) => setGuestName(e.target.value)}
                  placeholder="Nome o Nominativo"
                  required
                  disabled={isLoading}
                />
              </div>

              {error && <div className="error-alert">{error}</div>}

              <button
                type="submit"
                className="access-btn"
                style={project.color ? { backgroundColor: project.color } : {}}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm" role="status"></span>
                    Entrando in Coda...
                  </>
                ) : (
                  'ENTRA IN VIDEO CHIAMATA'
                )}
              </button>

              {!hideBackButton && (
                <button type="button" className="back-btn" style={{marginTop: 15}} onClick={goBack} disabled={isLoading}>
                  Torna Indietro
                </button>
              )}
            </form>
          </div>
        </div>
        {project.footer_logo && <div className="logo-container text-center mt-4">
          <img
            alt="Logo"
            className="text-center"
            src={project.footer_logo}
            style={{ maxWidth: '360px', width: '100%', marginTop: '10px' }}
          ></img>
        </div>}
      </div>

      {project.powered_by === 1 && <span style={{ position: 'absolute', bottom: 10, right: 10, fontSize: '0.8rem' }}>
        Powered by{' '}
        <img
          src="/media/logos/logo-meltingbugs.png"
          alt="Logo"
          style={{ height: '1.2rem', verticalAlign: 'middle' }}
        />
      </span>}
    </div>
  );
};

export default STAI2GuestAccess;
